import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import translations from "./translation.json";
import { useLanguage } from "./languageContext";
import { ApiUrl } from "./ApiUrl";
import { toast } from "react-toastify";

// const validationSchema = Yup.object({});

const VehicleEvaluationModal = ({
  initialData = null,
  onSubmit,
  isDarkMode,
  editId,
  setEditId,
  setProspectData,
  showPreviousModal = false,
  isLoadingVehicle,
}) => {
  // console.log("intial Data>>", initialData);
  const { language } = useLanguage();
const validationSchema = Yup.object({
  summer: Yup.boolean(),
  summer_tires_on: Yup.string().when("summer", {
    is: true,
    then: (schema) => schema.required("Please select an option for summer tires"),
    otherwise: (schema) => schema.notRequired(),
  }),

  winter: Yup.boolean(),
  winter_tires_on: Yup.string().when("winter", {
    is: true,
    then: (schema) => schema.required("Please select an option for winter tires"),
    otherwise: (schema) => schema.notRequired(),
  }),

  hybrid: Yup.boolean(),
  hybrid_tires_on: Yup.string().when("hybrid", {
    is: true,
    then: (schema) => schema.required("Please select an option for hybrid tires"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

  const defaultValues = {
    no_car_proof: false,
    car_proof: false,
    damage_location: "",
    damage_amount: "",
    summer_tires_on: "",
    winter_tires_on: "",
    hybrid: false,
    winter: false,
    summer: false,
    hybrid_tires_on: "",
    financing: "",
    next_vehicle: "",
    payment: "",
    options: "",
  };
  const formikRef = useRef(null);
  const initialValues = editId
    ? { ...defaultValues, ...initialData }
    : defaultValues;
  const modalRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      // console.log("asdkfhksfhadsfja")
      if (modalRef.current && !modalRef.current.contains(event.target)) {
      // console.log("asdkfhksfhadsfja outside")
        // Clicked outside the modal
        if (showPreviousModal) {
          document
            .querySelectorAll(".modal-backdrop")
            .forEach((backdrop) => backdrop.remove());
        }
        // formikRef.current?.resetForm();
        // setEditId(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPreviousModal, formikRef, setEditId]);
  var button = document.getElementById("closeVehicleModalBtn");
  return (
    <div
    ref={modalRef}
      id="vehicleModal"
      className="modal fade custom-vehicle-modal-header"
      tabIndex="-1"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          {/* Header */}
          <div
            className="modal-header  text-white "
            style={{
              borderBottom: isDarkMode
                ? "1px solid #495057"
                : "1px solid #dee2e6",
            }}
          >
            <h5 className="modal-title text-white">
              {translations.vehicleForm.title[language]}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              onClick={() => {
                if (showPreviousModal) {
                  document
                    .querySelectorAll(".modal-backdrop")
                    .forEach((backdrop) => {
                      backdrop.remove();
                    });
                  
                }
                var createModal = new window.bootstrap.Modal(
                    document.getElementById("editAppointmentModal")
                  );
                  createModal.show();
                formikRef.current?.resetForm();
                setEditId(null);
              }}
            ></button>
          </div>

          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize
            onSubmit={(values, helpers) => {
              onSubmit(values, helpers); // parent handles everything
            }}
            // onSubmit={async (values, { resetForm }) => {
            //   setIsLoading(true);

            //   try {
            //     const url = `${ApiUrl}/api/user/vehicle-assessment`;
            //     const method = "POST";

            //     const res = await fetch(url, {
            //       method,
            //       headers: {
            //         "Content-Type": "application/json",
            //         Authorization: `Bearer ${token}`,
            //       },
            //       body: JSON.stringify(values),
            //     });

            //     const data = await res.json();

            //     if (data.status === "success") {
            //       button?.click();

            //       // Close modal
            //       console.log("datadatadata",data)
            //       setProspectData((prev) => {
            //         if (!prev) return prev;
            //         const updatedAppointments = [...prev.appointments];
            //         if (updatedAppointments[0]) {
            //           updatedAppointments[0] = {
            //             ...updatedAppointments[0],
            //             vehicle_assessment: data.data,
            //           };
            //         }
            //         return {
            //           ...prev,
            //           appointments: updatedAppointments,
            //         };
            //       });
            //        toast.success(data?.message);

            //       // Reset Formik form

            //     } else {
            //       toast.error(data?.message);
            //     }

            //     setIsLoading(false);
            //   } catch (error) {
            //     console.error("Vehicle assessment error:", error);
            //     setIsLoading(false);
            //     toast.error(translations.alertMessages.wentWrong[language]);
            //   }
            // }}
          >
            {({ values, setFieldValue,errors,touched }) => (
              <Form>
                <div className="modal-body"  style={{
    maxHeight: "65vh",
    overflowY: "auto",
    paddingRight: "15px", // optional, prevent scrollbar overlap
  }}>
                  {/* Car Proof */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-6">
                      <div className="form-check">
                        <Field
                          style={{
                            backgroundColor: isDarkMode ? "transparent" : "",
                            color: isDarkMode ? "#ffffff" : "#000000",
                            border: isDarkMode
                              ? "1px solid #495057"
                              : "1px solid #dee2e6",
                          }}
                          type="checkbox"
                          className="form-check-input"
                          id="no_car_proof"
                          name="no_car_proof"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="no_car_proof"
                        >
                          {translations.vehicleForm.carProofNo[language]}
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-check">
                        <Field
                          style={{
                            backgroundColor: isDarkMode ? "transparent" : "",
                            color: isDarkMode ? "#ffffff" : "#000000",
                            border: isDarkMode
                              ? "1px solid #495057"
                              : "1px solid #dee2e6",
                          }}
                          type="checkbox"
                          className="form-check-input"
                          id="car_proof"
                          name="car_proof"
                        />
                        <label className="form-check-label" htmlFor="car_proof">
                          {translations.vehicleForm.carProofYes[language]}
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* Damage + Amount */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-8">
                      <label className="form-label" htmlFor="damage_location">
                        {translations.vehicleForm.damageLocation[language]}
                      </label>
                      <Field
                        type="text"
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                        className="form-control"
                        id="damage_location"
                        name="damage_location"
                        placeholder="Ex: aile avant droite"
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label" htmlFor="damage_amount">
                        {translations.vehicleForm.damageAmount[language]}
                      </label>
                      <Field
                        type="number"
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                        step="0.01"
                        className="form-control"
                        id="damage_amount"
                        name="damage_amount"
                        placeholder="0.00"
                      />
                    </div>
                  </div>

                  {/* Tires */}

                  <div className="mb-2">
                    <label className="form-label d-block">
                      {translations.vehicleForm.tires[language]}
                    </label>
                    <div className="row g-3">
                      {[
                        {
                          key: "summer",
                          label: translations.vehicleForm.summer[language],
                          checkName: "summer",
                          selectName: "summer_tires_on",
                        },
                        {
                          key: "winter",
                          label: translations.vehicleForm.winter[language],
                          checkName: "winter",
                          selectName: "winter_tires_on",
                        },
                        {
                          key: "hybrid",
                          label: translations.vehicleForm.hybrid[language],
                          checkName: "hybrid",
                          selectName: "hybrid_tires_on",
                        },
                      ].map((tire) => (
                        <div className="col-md-4" key={tire.key}>
                          <div className="input-group">
                            <span className="input-group-text" 
                              style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                            >
                              <Field
                                type="checkbox"
                                  style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                                className="form-check-input me-2"
                                name={tire.checkName}
                                // checked={values[tire.checkName] || false}
                                checked={Boolean(Number(values[tire.checkName]))}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setFieldValue(tire.checkName, checked);
                                  if (!checked) {
                                    setFieldValue(tire.selectName, ""); // uncheck resets to default
                                  }
                                }}
                              />
                              <label className="mb-0">{tire.label}</label>
                            </span>

                            <Field
                              as="select"
                              style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                              className="form-select"
                              name={tire.selectName}
                              disabled={!values[tire.checkName]}
                            >
                              <option
                                style={{
                                  background: isDarkMode ? "#1B1F22" : "",
                                  color: isDarkMode ? "#ffffff" : "",
                                }}
                                value=""
                                disabled={true}
                              >
                                select option
                              </option>
                              <option
                                style={{
                                  background: isDarkMode ? "#1B1F22" : "",
                                  color: isDarkMode ? "#ffffff" : "",
                                }}
                                value="on"
                              >
                                On…
                              </option>
                              <option
                                style={{
                                  background: isDarkMode ? "#1B1F22" : "",
                                  color: isDarkMode ? "#ffffff" : "",
                                }}
                                value="mags"
                              >
                                Mags
                              </option>
                              <option
                                style={{
                                  background: isDarkMode ? "#1B1F22" : "",
                                  color: isDarkMode ? "#ffffff" : "",
                                }}
                                value="rims"
                              >
                                Rims
                              </option>
                            </Field>
                            {errors[tire.selectName] && (touched[tire.selectName] || values[tire.checkName]) && (
                              <div className="error_color"  >
                                {errors[tire.selectName]}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="subtle-note mt-1">
                      (mags = Mags / rims = Rims)
                    </div>
                  </div>

                  {/* Financing */}
                  <div className="mb-3">
                    <label className="form-label d-block">
                      {translations.vehicleForm.financing[language]}
                    </label>
                    <div className="row g-3">
                      {[
                        {
                          id: "financed_bank",
                          label:
                            translations.vehicleForm.financedBank[language],
                        },
                        {
                          id: "lease",
                          label: translations.vehicleForm.lease[language],
                        },
                        {
                          id: "cash",
                          label: translations.vehicleForm.cash[language],
                        },
                      ].map((option) => (
                        <div className="col-md-4" key={option.id}>
                          <div className="form-check">
                            <Field
                              style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                              type="radio"
                              className="form-check-input"
                              id={option.id}
                              name="financing"
                              value={option.id}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={option.id}
                            >
                              {option.label}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="row g-3 mb-2">
                    <div className="col-md-12">
                      <label className="form-label" htmlFor="payment">
                        {translations.vehicleForm.payment[language]}?
                      </label>
                      <Field
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                        type="text"
                        className="form-control"
                        name="payment"
                        placeholder="payment"
                      />
                    </div>
                  </div>

                  {/* Next Vehicle / Options */}
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label" htmlFor="next_vehicle">
                        {translations.vehicleForm.nextVehicle[language]}?
                      </label>
                      <Field
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                        type="text"
                        className="form-control"
                        name="next_vehicle"
                        placeholder="Ex: Toyota RAV4"
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label" htmlFor="options">
                        {translations.vehicleForm.options[language]}?
                      </label>
                      <Field
                        style={{
                          backgroundColor: isDarkMode ? "transparent" : "",
                          color: isDarkMode ? "#ffffff" : "#000000",
                          border: isDarkMode
                            ? "1px solid #495057"
                            : "1px solid #dee2e6",
                        }}
                        type="text"
                        className="form-control"
                        name="options"
                        placeholder="Ex: AWD, cuir, toit ouvrant"
                      />
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div
                  className="modal-footer"
                  style={{
                    borderTop: isDarkMode
                      ? "1px solid #495057"
                      : "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    data-bs-dismiss="modal"
                    id="closeVehicleModalBtn"
                    onClick={() => {
                      if (showPreviousModal) {
                        document
                          .querySelectorAll(".modal-backdrop")
                          .forEach((backdrop) => {
                            backdrop.remove();
                          });
                        var createModal = new window.bootstrap.Modal(
                          document.getElementById("editAppointmentModal")
                        );
                        createModal.show();
                      }
                      formikRef.current?.resetForm();
                      setEditId(null);
                    }}
                  >
                    {translations.vehicleForm.close[language]}
                  </button>
                  <button
                    type="submit"
                    className="btn admin-btn"
                    disabled={isLoadingVehicle}
                  >
                    {translations.vehicleForm.save[language]}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default VehicleEvaluationModal;
